$(function(){
var options = {
      rules : {
        //'product[]': {required: true,min:1},
        giftS: {min:1,require_from_group : [1,".product"] },
        giftM: {min:1,require_from_group : [1,".product"] },  
        'pay[]': {required: true},
        month: {required: true},  
        day: {required: true},
        'time[]': {required: true},             
        name: {required: true},
        kana: {required: true},
        postalcode: {required: true,tel:true},
        address: {required: true},
        tel: {required: true,tel:true},            
        email:{required: true,email: true},       
        //"free-txt": {required: true},
        'privacy[]': {required: true},  
        quiz: {required: true,contents: true},
        'nospam[]': {required: true}  
        //mail:"email",
        //kochinews:"kochiNews"   
      },
groups : {
product : "giftS giftM"
},     
      messages: {
        'product[]':{required: "ご注文商品をお選びください",min: "ご注文商品をお選びください"},
        giftS:{require_from_group:"ご注文商品をお選びください"},
        giftM:{require_from_group:"ご注文商品をお選びください"},          
        'pay[]':{required: "お支払い方法をお選びください"},
        month:{required: "お届け希望日（月）をお選びください"},
        day:{required: "お届け希望日（日）をお選びください"},
        'time[]': {required: "お届け希望時間帯をお選びください"},  
        name:{required: "お名前をご入力ください"},
        kana:{required: "フリガナをご入力ください"},
        postalcode: {required: "郵便番号をご入力ください",tel:"正しい郵便番号を入力してください"},
        address: {required: "住所をご入力ください"},
        tel: {required: "電話番号をご入力ください",tel:"正しい電話番号を入力してください"},            
        email: {required:"メールアドレスをご入力ください",email:"正しいメールアドレスを入力してください"}, 
        //"free-txt": {required:"お問い合わせ内容をご入力ください"},
        'privacy[]': {required:"チェックを入れてください"},
        'nospam[]': {required:"チェックを入れてください"},  
        quiz: {required:"「高知」とご入力ください",contents:"正しくご入力ください"} 
      },
   
// エラーメッセージの表示先を指定する
    	errorPlacement: function(error, el) {
        if(el.attr("name")=="privacy[]"){
        $('#privacyError').append(error);
        }
        else if(el.attr("name")=="nospam[]"){
        $('#nospamError').append(error);
        }
        else if(el.attr("name")=="quiz"){
        $('#quizError').append(error);
        }
//        else if(el.attr("name")=="giftS"){
//        $('#productError').append(error);
//        }
//        else if(el.attr("name")=="giftM"){
//        $('#productError').append(error);
//        } 
        else if(el.hasClass("product")){
        $('#productError').append(error);
        }            
        else if(el.attr("name")=="pay[]"){
        $('#payError').append(error);
        }
        else if(el.attr("name")=="month"){
        $('#dayError').append(error);
        }
        else if(el.attr("name")=="day"){
        $('#dayError').append(error);
        }
        else if(el.attr("name")=="time[]"){
        $('#timeError').append(error);
        }            
        else{
		el.parent().children('.error-message').append(error);
        }
	},
 
    errorElement:"span",
    focusInvalid:false,
}   

    
  var methods = {
   contents: function(value, element){
      return this.optional(element) || /^高知$/.test(value);
    },
    tel: function(value, element){
      return this.optional(element) || /^[ー−0-9０-９\-]+$/.test(value);
    },     
  };

//メソッドの追加
  $.each(methods, function(key) {
  $.validator.addMethod(key, this);
  });

//エラー箇所に戻る動き        
var onClickHandler = function(){
var mql = window.matchMedia('screen and (min-width: 768px)');
    setTimeout(function () {
    var errorPoint = ($('.error:visible').eq(0).offset().top);
    //var errorPoint = ($('.error-message:visible').get(0).offsetTop);
    var height = 20;
    if (mql.matches) {
    var height = 20;    
    }    
    var errorPos = errorPoint - height;    
    //console.log(errorPos);
    $('html,body').animate(
      {scrollTop: errorPos},'easeInOutQuad');
        return false;
         }, 300);
  }

$("#contact-form").validate(options);   
$(".form-btn--check").bind('click touchstart', onClickHandler);
});  